import { Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing.component';
import { AboutComponent } from './pages/main/about/about.component';
import { MainComponent } from './pages/main/main.component';
import { ChatEnhancedComponent } from './pages/chat-enhanced/chat-enhanced.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AuthGuard } from './guards/auth.guard';
import { NewThreadResolver } from './services/new-thread.resolver';


export const routes: Routes = [
  { path: 'landing', component: LandingComponent },
  { path: 'access-denied', component: AccessDeniedComponent },
  {
    path: 'main',
    component: MainComponent,
    children: [
      { path: 'chat-enhanced', component: ChatEnhancedComponent, resolve: { threads: NewThreadResolver } },
      { path: 'chat-enhanced/:threadId', component: ChatEnhancedComponent },
      { path: 'about', component: AboutComponent },
      { path: '**', redirectTo: 'chat-enhanced' }
    ],
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: 'landing' }
];
